"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.imagePropType = exports.dataType = exports.ctaPropType = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = require("@mmc/text");
var ctaPropType = _propTypes["default"].shape({
  label: _propTypes["default"].string,
  URL: _propTypes["default"].string
});
exports.ctaPropType = ctaPropType;
var imagePropType = _propTypes["default"].shape({
  image: _propTypes["default"].string,
  altText: _propTypes["default"].string
});
exports.imagePropType = imagePropType;
var dataType = _propTypes["default"].shape({
  resourceType: _propTypes["default"].string,
  componentLabel: _propTypes["default"].string,
  heading1: _propTypes["default"].string,
  heading2: _propTypes["default"].string,
  textBlock: _propTypes["default"].string,
  cta: ctaPropType,
  image: imagePropType,
  aspectRatio: _propTypes["default"].string,
  theme: _propTypes["default"].string,
  size: _propTypes["default"].string,
  carAlignment: _propTypes["default"].string,
  headingTag: _propTypes["default"].string,
  disclaimerData: _text.disclaimerDataPropTypes
});
exports.dataType = dataType;